module.exports = __webpack_public_path__ + "img/title6.82dc6a3f.png";